import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "264",
  height: "107",
  viewBox: "0 0 264 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"187\" y=\"13\" width=\"8\" height=\"82\" rx=\"4\" fill=\"var(--dt-color-surface-primary)\"></rect><rect x=\"68\" y=\"28\" width=\"96\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-surface-moderate)\"></rect><rect x=\"68\" y=\"48\" width=\"68\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-surface-moderate)\"></rect><rect x=\"68\" y=\"68\" width=\"80\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-surface-moderate)\"></rect><rect x=\"187\" y=\"29\" width=\"8\" height=\"40\" rx=\"4\" fill=\"var(--dt-color-foreground-placeholder)\"></rect>", 5)
  ]))]))
}
export default { render: render }